'use strict';
var parent = require('../../es/object/entries');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/stable/object/entries.js
// module id = 493
// module chunks = 0